import { Component } from 'react';

export default class LoadBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (!this.state.failed) return this.props.children;
    return <div className="content-status" role="alert">
      <p>This section couldn’t load. Please reload to try again.</p>
      <button type="button" className="text-link" onClick={() => window.location.reload()}>Reload page</button>
      <p>Or <a href="tel:+17724945048">call our crew at (772) 494-5048</a>.</p>
    </div>;
  }
}
